
/**
 * Fragment Detection Constants
 *
 * MIN_REGION_SIZE và MIN_WARNING_SIZE có thể được chỉ định theo 2 cách:
 *
 * 1. Số (pixels²) :
 *    MIN_REGION_SIZE: 100  // 100 pixels²
 *
 * 2. Object với đơn vị mm² - sử dụng DPI để chuyển đổi:
 *    MIN_REGION_SIZE: {value: 0.1, unit: 'mm', dpi: 300}  // 0.1 mm² ở 300 DPI
 *
 * Khi sử dụng trong detectFragments(), có thể truyền DPI riêng:
 *    detectFragments(imageData, {
 *        minRegionSize: {value: 0.1, unit: 'mm'},  // DPI sẽ lấy từ options.dpi
 *        dpi: 300  // DPI của background/image
 *    })
 *
 * Ví dụ chuyển đổi:
 * - 0.1 mm² @ 300 DPI ≈ 13.9 pixels²
 * - 1 mm² @ 300 DPI ≈ 139 pixels²
 * - 0.1 mm² @ 72 DPI ≈ 0.8 pixels²
 */
export const FRAGMENT_DETECTION = {
    // Minimum area to consider as fragment
    // Can be specified as:
    // - Number (pixels²): MIN_REGION_SIZE: 100
    // - Object with unit: MIN_REGION_SIZE: {value: 0.1, unit: 'mm', dpi: 300}
    MIN_REGION_SIZE: 1, // pixels² - minimum area to consider as fragment (lowered to detect very small fragments like dots)
    MIN_WARNING_SIZE: 50, // pixels² - fragments smaller than this will trigger stronger warning (e.g., small text strokes, dots)
    MIN_NOISE_FILTER: 2, // pixels² - fragments with area <= this are considered noise/artifacts and will be filtered out
    MIN_THICKNESS: 2, // pixels - minimum local thickness for manufacturing constraints (printing/cutting/CNC). Regions thinner than this will be flagged with warning
    DETECTION_DEBOUNCE_MS: 300,
    MAX_CANVAS_SIZE: 2000, // downscale if larger
    BFS_TIMEOUT_MS: 500, // fallback to OpenCV if slower
    ALPHA_THRESHOLD: 254, // Alpha threshold for binary mask (0-255)
    HIGHLIGHT_COLORS: {
        warning: '#ff9800',
        error: '#f44336',
        info: '#2196f3',
    },
}

